t = require('views/internal/teacup-with-helpers')('popover_selector_menu')

module.exports = ->
  t.ul '.pop-over-list', ->
    t.li ->
      t.a '.js-mem-selector', { href: '#' }, ->
        t.format 'members-ellipsis'
    t.li ->
      t.a '.js-label-selector', { href: '#' }, ->
        t.format 'labels-ellipsis'
    t.li ->
      t.a '.js-pos-selector', { href: '#' }, ->
        t.format 'position-ellipsis'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/popover_selector_menu.coffee